var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1.58333C0.25 0.985333 0.735333 0.5 1.33333 0.5C1.93133 0.5 2.41667 0.985333 2.41667 1.58333C2.41667 2.18133 1.93133 2.66667 1.33333 2.66667C0.735333 2.66667 0.25 2.18133 0.25 1.58333ZM0.25 7C0.25 6.402 0.735333 5.91667 1.33333 5.91667C1.93133 5.91667 2.41667 6.402 2.41667 7C2.41667 7.598 1.93133 8.08333 1.33333 8.08333C0.735333 8.08333 0.25 7.598 0.25 7ZM1.33333 11.3333C0.735333 11.3333 0.25 11.8187 0.25 12.4167C0.25 13.0147 0.735333 13.5 1.33333 13.5C1.93133 13.5 2.41667 13.0147 2.41667 12.4167C2.41667 11.8187 1.93133 11.3333 1.33333 11.3333ZM5.59679 5.91667H18.7365C19.2945 5.91667 19.7505 6.37275 19.7505 6.93067V7.06933C19.7505 7.62725 19.2945 8.08333 18.7365 8.08333H5.59679C5.03888 8.08333 4.58388 7.62725 4.58388 7.06933V6.93067C4.58388 6.37275 5.03888 5.91667 5.59679 5.91667ZM18.7365 11.3333H5.59679C5.03888 11.3333 4.58388 11.7894 4.58388 12.3473V12.486C4.58388 13.0439 5.03888 13.5 5.59679 13.5H18.7365C19.2945 13.5 19.7505 13.0439 19.7505 12.486V12.3473C19.7505 11.7894 19.2945 11.3333 18.7365 11.3333ZM5.59679 0.5H18.7365C19.2945 0.5 19.7505 0.956083 19.7505 1.514V1.65267C19.7505 2.21058 19.2945 2.66667 18.7365 2.66667H5.59679C5.03888 2.66667 4.58388 2.21058 4.58388 1.65267V1.514C4.58388 0.956083 5.03888 0.5 5.59679 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c58ed943a80acf35f6ec61ec0d2d9547.svg";
export { ForwardRef as ReactComponent };